function isPageInactive() {
  if (typeof document === "undefined") return false;
  return document.visibilityState === "hidden" || document.hidden;
}

/**
 * Indica se devemos exibir notificação nativa do navegador.
 * Em background (aba/janela inativa): basta permissão concedida.
 * Com a janela visível: respeita a preferência desktopEnabled e foco no conteúdo.
 */
export function shouldShowDesktopNotification({
  desktopEnabled,
  skipDesktop,
  isContentFocused,
}) {
  if (skipDesktop) return false;
  if (typeof Notification === "undefined" || Notification.permission !== "granted") {
    return false;
  }
  const inactive = isPageInactive();
  if (inactive) return true;
  if (!desktopEnabled) return false;
  return !isContentFocused;
}

async function resolvePushRegistration() {
  if (!("serviceWorker" in navigator)) return null;
  try {
    let reg = await navigator.serviceWorker.getRegistration("/sw-push.js");
    if (!reg) reg = await navigator.serviceWorker.getRegistration();
    if (reg) return reg;
    reg = await navigator.serviceWorker.register("/sw-push.js");
    return reg;
  } catch {
    return null;
  }
}

/**
 * Exibe notificação do sistema via service worker (preferido em background) ou Notification API.
 */
export async function showDesktopNotification({ title, body, tag, url, onNavigate }) {
  if (typeof window === "undefined" || !("Notification" in window)) return false;
  if (Notification.permission !== "granted") return false;

  const targetUrl = url || "/";
  const options = {
    body: body || undefined,
    tag: tag || undefined,
    icon: "/brands/xpro/android-icon-192x192.png",
    badge: "/brands/xpro/android-icon-192x192.png",
    data: { url: targetUrl },
  };

  try {
    const reg = await resolvePushRegistration();
    if (reg) {
      await reg.showNotification(title, options);
      return true;
    }
  } catch {
    /* fallback abaixo */
  }

  try {
    const n = new Notification(title, options);
    n.onclick = () => {
      window.focus();
      if (onNavigate) onNavigate();
      else if (targetUrl) {
        try {
          window.location.assign(new URL(targetUrl, window.location.origin).href);
        } catch {
          /* ignore */
        }
      }
      n.close();
    };
    return true;
  } catch {
    return false;
  }
}

export { isPageInactive };
